import { render, staticRenderFns } from "./ItemShortDiscrepancy.vue?vue&type=template&id=64b5b694&"
import script from "./ItemShortDiscrepancy.vue?vue&type=script&lang=js&"
export * from "./ItemShortDiscrepancy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports